export default __webpack_public_path__ + "static/media/online-facilitation.f2353a5a.svg";